import { Component, inject, OnInit } from '@angular/core';

import { RouterModule } from '@angular/router';
import { SessionManager } from '@experian/authentication';
import { SedsModalAbstractComponent, SedsModalModule } from 'experian-design-system';
import { TourEnum } from '../tour/tour.enum';
import { GuidedTourModule, GuidedTourService } from 'ngx-guided-tour';
import { stepsTour } from '../../../../src/app/services/steps';

@Component({
    templateUrl: 'modal-virtual-tour.component.html',
    styleUrls: ['modal-virtual-tour.component.scss'],
    imports: [
        GuidedTourModule,
        RouterModule,
        SedsModalModule
    ]
})
export class ModalVirtualTourComponent extends SedsModalAbstractComponent implements OnInit  {

  public isTouring: boolean;
  public tourStatePrefix = 'virtual-tour-';
  public userId: string;
  public guidedTour = stepsTour;
  public accessToken: string;

  private tourService: GuidedTourService;
  private sessionManager: SessionManager;

  constructor() { 
    super();

    this.tourService = inject(GuidedTourService);
    this.sessionManager = inject(SessionManager);
  }

  ngOnInit() { 
    super.ngOnInit();
    this.userId = this.data.userId;

    this.sessionManager.logout$.subscribe(_ => {
      this.close();
    });
  }

  public skippedTour(): void {
    this._closeTourModal(TourEnum.SKIPPED);
  }

  public startTour(force = false): void {
    this.isTouring = true;
    this.tourService.startTour(this.guidedTour);
  }  

  public clickModalInitTour() {
    this.close();

    setTimeout(() => {
      this.startTour(true);
    }, 500);
  }

  private _closeTourModal(tourState: TourEnum): void {
    this.isTouring = false;
    localStorage.setItem(
      this.tourStatePrefix + this.userId,
      tourState
    );    

    this.close({ data: 'Fechou' });
    window.scrollTo({ top: 1 });
    window.scroll(0, 0);        
  }

}